export enum MqttEvent {
  Charge = 'charge',
  Drop = 'drop',
  Dryend = 'dryend',
  Manual = 'manual',
  Firstcrack = 'firstcrack',
}
